import { cancelReason } from '@mgo/core/src/validations/coac';

export default { cancelReason };
